var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotedMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33574",
    "data-name": "Group 33574",
    transform: "translate(18078 21811)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9773",
    "data-name": "Rectangle 9773",
    width: 18,
    height: 18,
    transform: "translate(-18078 -21811)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70477",
    "data-name": "Path 70477",
    d: "M17,11.667a1.777,1.777,0,0,1-1.778,1.778H4.556L1,17V2.778A1.777,1.777,0,0,1,2.778,1H15.222A1.777,1.777,0,0,1,17,2.778Z",
    transform: "translate(-18078 -21811)",
    fill: "none",
    stroke: "#5076ba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33579",
    "data-name": "Group 33579",
    transform: "translate(-737 -311.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M2.386,15.548V12.9H6.873l-3.9,2.942a.363.363,0,0,1-.22.075A.369.369,0,0,1,2.386,15.548ZM1.952,12.9A1.952,1.952,0,0,1,0,10.949v-9A1.952,1.952,0,0,1,1.952,0h12.1A1.952,1.952,0,0,1,16,1.952v9A1.952,1.952,0,0,1,14.049,12.9Z",
    transform: "translate(-17340 -21498)",
    fill: "#5076ba",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70480",
    "data-name": "Path 70480",
    d: "M54.442,55.535H47.861a.763.763,0,1,1,0-1.526h6.581a.763.763,0,0,1,0,1.526",
    transform: "translate(-17383.154 -21547.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70481",
    "data-name": "Path 70481",
    d: "M51.42,91.279H47.862a.763.763,0,0,1,0-1.526H51.42a.763.763,0,0,1,0,1.526",
    transform: "translate(-17383.152 -21580.232)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotedMessage);
export default __webpack_public_path__ + "static/media/noted-message.9268e4a945fcc9907866b72e81a023d8.svg";
export { ForwardRef as ReactComponent };